// extracted by mini-css-extract-plugin
export default {"overlay":"SidePopup_overlay__kyrCN","container":"SidePopup_container__XhI4N","open":"SidePopup_open__7ewTm","top":"SidePopup_top__UgV+E"};